// Lib
import { YOUTUBE } from '@/lib/socialProfile';
import { getPostType } from '@/lib/posts/postTypes';
import { YT_POST_ICONS } from '@/lib/posts/postIcon';

// Components
import Post from '@/components/base/Post';
import { AlbumPostIcon } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/post/AlbumPostIcon';

// Types
import type { YTPostTypesType } from '@/lib/posts/postTypes';

type YoutubeAlbumPostProps = {
    data: {
        type: YTPostTypesType;
    };
    shouldDisplayIcon: boolean;
};

const YoutubeAlbumPost = ({ data, shouldDisplayIcon }: YoutubeAlbumPostProps) => {
    const type = getPostType({ network: YOUTUBE, type: data?.type });

    return (
        <Post data={data} className="w-full">
            <Post.Content className="relative w-full">
                <AlbumPostIcon show={type && shouldDisplayIcon} type={YT_POST_ICONS[type]} />
                <div className="square relative">
                    <Post.Image />
                </div>
            </Post.Content>
        </Post>
    );
};

export default YoutubeAlbumPost;
